import React, { useEffect, useRef, useState } from "react";

/**
 * MicPicker — the caret beside the mic in the voice pill (Plan F). A listbox
 * of audio inputs, the current one checked. Not a native <select>: it has to
 * sit inside the pill and close on an outside tap.
 */
export default function MicPicker({ devices, deviceId, onPick }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const away = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", away);
    document.addEventListener("touchstart", away);
    return () => { document.removeEventListener("mousedown", away); document.removeEventListener("touchstart", away); };
  }, [open]);
  if (!devices?.length) return null;
  const current = deviceId || devices[0]?.deviceId;
  return (
    <span ref={ref} style={m.wrap}>
      <button type="button" aria-haspopup="listbox" aria-expanded={open} aria-label="Choose microphone"
              style={m.caret} onClick={e => { e.stopPropagation(); setOpen(o => !o); }}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
      </button>
      {open && (
        <ul role="listbox" aria-label="Microphones" style={m.list}>
          {devices.map((d, i) => {
            const on = d.deviceId === current;
            return (
              <li key={d.deviceId || i} role="option" aria-selected={on} style={{ ...m.item, ...(on ? m.itemOn : {}) }}
                  onClick={e => { e.stopPropagation(); setOpen(false); onPick?.(d.deviceId); }}>
                <span style={m.check}>{on ? "✓" : ""}</span>
                {d.label || `Microphone ${i + 1}`}
              </li>
            );
          })}
        </ul>
      )}
    </span>
  );
}

const m = {
  wrap:   { position: "relative", display: "inline-flex" },
  caret:  { font: "inherit", background: "none", border: "none", padding: "6px 4px", cursor: "pointer", color: "var(--color-text-secondary)", display: "inline-flex", alignItems: "center" },
  list:   { position: "absolute", top: "100%", left: -8, marginTop: 8, listStyle: "none", padding: 6, minWidth: 260, background: "var(--color-surface)", border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", zIndex: 30 },
  item:   { display: "grid", gridTemplateColumns: "18px 1fr", alignItems: "center", gap: 6, padding: "8px 10px", borderRadius: "var(--radius-md)", fontSize: "var(--text-sm)", color: "var(--color-text-primary)", cursor: "pointer", whiteSpace: "nowrap" },
  itemOn: { fontWeight: "var(--weight-medium)" },
  check:  { color: "var(--color-accent)", textAlign: "center" },
};
